import { Icon, Combobox } from "web/components"

const FILTERABLE_KINDS = [
  "Area",
  "Boolean",
  "Contact",
  "Company",
  "Date",
  "InternalContact",
  "Length",
  "Lookup",
  "Money",
  "Number",
  "Portfolio",
  "User",
  "Text",
]

const filterNonFilterableKinds = (fields) =>
  fields.filter((el) => FILTERABLE_KINDS.includes(el.kind))

export default function AddConditionDropDown({
  fields,
  hasComparableFilters,
  hasDistanceFilterSelected,
  onAddFieldCondition,
  onAddDistanceCondition,
  onCancel,
  recommendedFilters = [],
}) {
  const filterableFields = filterNonFilterableKinds(fields)

  const recommendedFields = filterableFields.filter((sf) =>
    recommendedFilters.includes(sf.key)
  )

  const hasRecommendedFields = recommendedFields.length > 0
  const showDistanceOption = hasComparableFilters && !hasDistanceFilterSelected
  const showRecommendedSection = hasRecommendedFields || showDistanceOption

  return (
    <div className="md:max-h-100 flex min-h-full max-w-full flex-col md:min-h-xs md:min-w-xs md:max-w-lg">
      <div className="flex items-center justify-between p-4">
        <div className="text-lg font-bold">Filter By</div>
        <Icon
          width="25px"
          height="25px"
          name="x-mark"
          className="cursor-pointer"
          onClick={onCancel}
        />
      </div>
      <hr />
      <div className={"overflow-auto p-4 sm:min-h-xs"}>
        <Combobox
          items={filterableFields}
          displayValueFn={(field) => field.label}
          keyFn={(field) => field.key}
          testId="field-filter"
          onChange={onAddFieldCondition}
        />
        {showRecommendedSection && (
          <>
            <div className="mb-2 mt-4 text-sm text-neutral-4">
              Recommended Filters
            </div>
            <div className="flex flex-wrap p-1">
              {showDistanceOption && (
                <DistanceFilterOption
                  onAddDistanceCondition={onAddDistanceCondition}
                />
              )}
              {recommendedFields.map((field) => (
                <FilterSuggestion
                  label={field.label}
                  testId={`recommended-filter-condition-${field.name}`}
                  key={field.name}
                  onClick={() => onAddFieldCondition(field)}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

function DistanceFilterOption({ onAddDistanceCondition }) {
  return (
    <FilterSuggestion
      label="Distance"
      testId="recommended-filter-condition-distance"
      key="distance"
      onClick={() => {
        onAddDistanceCondition({
          type: "View::SpatialTypeDistanceCondition",
        })
      }}
    />
  )
}

function FilterSuggestion({ label, testId, onClick }) {
  return (
    <div
      data-testid={testId}
      className="mx-1 my-1 cursor-pointer rounded-full border border-neutral-8 px-4 py-1 text-sm font-bold hover:border-primary-8 hover:bg-primary-10"
      onClick={onClick}
    >
      {label}
    </div>
  )
}
